import type { Optional } from 'utility-types';



export enum ImageType {
	Cover = 'cover',
	CoverLarge = 'cover_large',
	CoverSmall = 'cover_small',
	Title = 'title',
	Logo = 'logo',
	LogoInverted = 'logo_inverted',
	Poster = 'poster',
	Slides = 'slides',
	Icon = 'icon'
}

export type Image = {
	order: number;
	url: string;
};

type Images = Record<ImageType, Image[]>;

type OptionalImages<T extends ImageType[]> = Optional<Pick<Images, T[number]>> | null;

// NOTE: If you know what types of images product contains use the product-specific type like VodImages
export type ProductImages = Optional<Images> | null;

export type ProgramImages = OptionalImages<[ImageType.Cover, ImageType.Slides]>;

export type ChannelImages = OptionalImages<[ImageType.Logo, ImageType.LogoInverted]>;

export type VodImages = OptionalImages<[ImageType.Cover, ImageType.Poster, ImageType.Title]>;

export type BannerImages = OptionalImages<[ImageType.Cover, ImageType.CoverSmall]>;

export type PacketImages = OptionalImages<[ImageType.CoverLarge, ImageType.CoverSmall]>;

export type SectionImages = OptionalImages<[ImageType.CoverLarge, ImageType.Cover]>;

export type ChannelGenreImages = OptionalImages<[ImageType.Icon]>;
